import { AdaptivaPackageBrowserConfigFactory, BaseBrowserConfigFactory, BrowserConfigFactoryService, ClassLevelPermissionsBrowserConfigFactory, ClientSettingsServerPolicyBrowserConfigFactory, DefaultBrowserConfigFactory, EJavaClassNames, GroupBrowserConfigFactory, ServerObject } from '@adaptiva/data-service';
import { Type } from '@angular/core';

export const PLATFORM_BROWSER_CONFIG_FACTORIES: Record<string, Type<BaseBrowserConfigFactory<ServerObject>>> = {
	[EJavaClassNames.AdaptivaPackage]: AdaptivaPackageBrowserConfigFactory,
	[BrowserConfigFactoryService.DEFAULT_KEY]: DefaultBrowserConfigFactory,
	[EJavaClassNames.ClassLevelPermissions]: ClassLevelPermissionsBrowserConfigFactory,
	[EJavaClassNames.ClientSettingsServerPolicy]: ClientSettingsServerPolicyBrowserConfigFactory,
	[EJavaClassNames.Group]: GroupBrowserConfigFactory,
};
